import { createBuilderModule } from '../../../builder';
import { TIME_INPUT } from '../utils';
import { Session } from './Session';

export default createBuilderModule(Session, {
  name: 'Session',
  inputs: [
    { name: 'isFeatured', type: 'boolean' },
    {
      name: 'track',
      required: true,
      type: 'string',
      enum: ['All tracks', 'Build', 'Attract', 'Innovate', 'Extend'],
    },
    {
      name: 'type',
      type: 'string',
      enum: ['Keynote', 'Networking', 'Breakout'],
      required: true,
    },
    { ...TIME_INPUT, name: 'startTime', required: true },
    { ...TIME_INPUT, name: 'endTime', required: true },
    { name: 'title', type: 'string', required: true },
    {
      name: 'description',
      type: 'richText',
    },
    {
      name: 'speakers',
      type: 'list',
      subFields: [
        {
          name: 'name',
          type: 'string',
          required: true,
        },
        { name: 'title', type: 'string', required: true },
        { name: 'imageURL', type: 'cloudinaryImage', required: true },
      ],
    },
    {
      name: 'placeholderImages',
      type: 'object',
      showIf: (options) => !options.get('speakers')?.length,
      subFields: [
        {
          name: 'mobile',
          type: 'cloudinaryImage',
        },
        {
          name: 'tablet',
          type: 'cloudinaryImage',
        },
        {
          name: 'desktop',
          type: 'cloudinaryImage',
        },
      ],
    },
    {
      name: 'backgroundImages',
      showIf: (options) => options.get('speakers')?.length > 0,
      type: 'object',
      subFields: [
        {
          name: 'tall',
          type: 'cloudinaryImage',
        },
        {
          name: 'wide',
          type: 'cloudinaryImage',
        },
        {
          name: 'square',
          type: 'cloudinaryImage',
        },
      ],
    },
  ],
});
